const CONSTANTS = {
    // reports
    ON_SAVING_POTENTIALS_LIST_IS_LOADING: 'reports/ON_SAVING_POTENTIALS_LIST_IS_LOADING',
    ON_SAVING_POTENTIALS_LIST: 'reports/ON_SAVING_POTENTIALS_LIST'
};

export { CONSTANTS };
